import { render, staticRenderFns } from "./RiskAssessmentDialog.vue?vue&type=template&id=3e5a8558&scoped=true&"
import script from "./RiskAssessmentDialog.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentDialog.vue?vue&type=style&index=0&id=3e5a8558&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a8558",
  null
  
)

export default component.exports